export const leaveHighlightCardStyle = {
  wrapper: {
    border: '0.125rem solid ',
    borderColor: 'neutral.300',
    p: '3rem',
    borderRadius: '0.75rem',
    backgroundColor: 'common.white',
  },
};
